define("auth/controllers/accept_invite", ["exports", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking", "later/utils/constants", "later/utils/fetch"], function (_exports, _controller, _object, _service, _tracking, _constants, _fetch) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"later/utils/constants",0,"later/utils/fetch"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  let AcceptInviteController = _exports.default = (_class = class AcceptInviteController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "session", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      _defineProperty(this, "queryParams", ['invite_type']);
      _defineProperty(this, "invitation_token", '');
      _defineProperty(this, "invite_type", '');
      _initializerDefineProperty(this, "submitEnabled", _descriptor6, this);
      _initializerDefineProperty(this, "fullName", _descriptor7, this);
      _initializerDefineProperty(this, "password", _descriptor8, this);
      _initializerDefineProperty(this, "serverError", _descriptor9, this);
      _initializerDefineProperty(this, "nameInputIsTouched", _descriptor10, this);
    }
    get formSubtext() {
      return this.invite_type === 'contributor' ? this.intl.t('contributions.contributor_title').toLowerCase() : this.intl.t('shared_words.user').toLowerCase();
    }
    get submitDisabled() {
      return !(this.fullName?.trim().length > 0 && this.password?.length > 0) || !this.submitEnabled;
    }
    get nameInputErrorMessage() {
      return this.fullName?.trim().length === 0 && this.nameInputIsTouched ? this.intl.t('errors.blank', {
        description: this.intl.t('shared_words.name')
      }) : '';
    }
    async acceptInvite() {
      const urlencoded = new URLSearchParams();
      urlencoded.append('user[invitation_token]', this.invitation_token);
      urlencoded.append('user[name]', this.fullName);
      urlencoded.append('user[password]', this.password);
      urlencoded.append('user[password_confirmation]', this.password);
      this.serverError = undefined;
      this.submitEnabled = false;
      return (0, _fetch.fetch)('/users/invitation', {
        method: _constants.HttpMethod.Put,
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: urlencoded
      }).then(data => {
        this.submitEnabled = true;
        if (this.auth.isKeycloak) {
          if (data.email) {
            this.router.transitionTo('user.login');
          }
        } else {
          return this.session.authenticate('authenticator:custom', data.email).catch(reason => {
            alert(reason.error || reason);
          });
        }
      }).catch(error => {
        this.submitEnabled = true;
        this.serverError = error.message;
        this.errors.log(error);
      });
    }
    markNameInputAsTouched() {
      this.nameInputIsTouched = true;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "session", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "submitEnabled", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "fullName", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "password", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "serverError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "nameInputIsTouched", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "acceptInvite", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "acceptInvite"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markNameInputAsTouched", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "markNameInputAsTouched"), _class.prototype)), _class);
});